/* Patina V9.2.14: update responsive image hints after fold/unfold, rotation,
 * bfcache return or section replacement. No new image URLs, commerce writes,
 * click interception, polling or document-wide mutation observer. */
(() => {
  'use strict';
  if (window.PatinaResponsive9214) return;
  const instances = new Map();
  let frame = 0;
  const queue = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = 0; update(); });
  };
  const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(queue) : null;
  function sync() {
    for (const [element, record] of instances) {
      if (!element.isConnected) { observer?.unobserve(record.target); instances.delete(element); }
    }
    document.querySelectorAll('#MainContent .product-information__media > media-gallery').forEach(gallery => {
      const previous = instances.get(gallery);
      if (previous?.target.isConnected) return;
      if (previous) observer?.unobserve(previous.target);
      const stage = gallery.querySelector(':scope > slideshow-component > slideshow-container');
      const target = stage || gallery;
      instances.set(gallery, { target, width: 0 });
      observer?.observe(target);
    });
    queue();
  }
  function update() {
    const viewportHeight = Math.max(1, document.documentElement.clientHeight || window.innerHeight || 1);
    for (const [gallery, record] of instances) {
      if (!gallery.isConnected) { observer?.unobserve(record.target); instances.delete(gallery); continue; }
      const layout = gallery.closest('.product-information');
      const viewportValue = `${viewportHeight}px`;
      if (layout && layout.style.getPropertyValue('--ps-product-viewport-height') !== viewportValue) {
        layout.style.setProperty('--ps-product-viewport-height', viewportValue);
      }
      const width = Math.ceil(record.target.getBoundingClientRect().width);
      // Do not save a transient zero-width hint while a theme section is hidden.
      if (!Number.isFinite(width) || width < 24) continue;
      record.width = width;
      // Only main gallery images; leave thumbnails, zoom and product-card hints alone.
      gallery.querySelectorAll(':scope > slideshow-component .product-media__image[srcset]').forEach(image => {
        const hint = `${width}px`;
        if (image.getAttribute('sizes') !== hint) image.setAttribute('sizes', hint);
      });
    }
  }
  window.addEventListener('resize', sync, { passive: true });
  window.addEventListener('orientationchange', sync, { passive: true });
  window.addEventListener('pageshow', sync);
  window.visualViewport?.addEventListener('resize', queue, { passive: true });
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:section:unload', sync);
  document.addEventListener('shopify:section:reorder', queue);
  document.addEventListener('patina:productsrendered', sync);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) sync(); });
  window.PatinaResponsive9214 = { refresh: sync, version: '9.2.14' };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
})();
